import { GameSpeed } from "./interface"


export const DEFAULT_SPEED: GameSpeed = "normal"
